/**
 * Placeholder images for the application
 * Replace these files in the public folder with actual images
 */

export const PLACEHOLDER_IMAGES = {
  product: '/images/placeholder-product.png',
  offer: '/images/placeholder-offer.png',
  avatar: '/images/placeholder-avatar.png',
} as const;

/**
 * Inline SVG placeholder for products (used as fallback)
 */
export const PRODUCT_PLACEHOLDER_SVG = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='300' viewBox='0 0 400 300'%3E%3Crect width='400' height='300' fill='%23E5E7EB'/%3E%3Cg transform='translate(150 100)'%3E%3Crect x='20' y='30' width='60' height='60' fill='%239CA3AF' rx='4'/%3E%3Cpath d='M35 55 L50 70 L65 50' stroke='%23fff' stroke-width='3' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3Ctext x='200' y='180' text-anchor='middle' font-family='Arial, sans-serif' font-size='14' fill='%239CA3AF'%3EAucune image disponible%3C/text%3E%3C/svg%3E`;
